import { computed } from 'mobx';
import _ from 'lodash';
import CalculationFormData from '../../stores/tool/CalculationFormStore';
import SavingsData from '../../stores/tool/SavingsStore';

class ActiveStepsStore {
  allSteps = ['step-1', 'step-2', 'step-3'];

  /* Add steps that are always active */
  activeStepsArray = ['step-1'];

  /* Add conditions */
  @computed get activeSteps() {
    if (CalculationFormData.labelInterests.length > 0 &&
      this.activeStepsArray.indexOf('step-2') === -1) {
      this.activeStepsArray.push('step-2');
    }

    if (!_.isEmpty(SavingsData.loanpartsResult) &&
      this.activeStepsArray.indexOf('step-3') === -1) {
      this.activeStepsArray.push('step-3');
    }

    return this.activeStepsArray;
  }

}

const ActiveStepsData = new ActiveStepsStore();

export default ActiveStepsData;
